export default __webpack_public_path__ + "static/media/info.82500080.svg";